import useRouter from 'hooks/use-router'
import { useEffect } from 'react'
import useMainClass from 'hooks/use-main-cass'
import ErrorViewComponent from 'components/error-view'

const ErrorView = () => {
  const { push, history, match } = useRouter()
  const errorId = parseInt(match.params.errorid, 10) || 9999
  useMainClass('error')
  useEffect(() => {
    const event = new CustomEvent('background-color', {
      detail: {
        shouldUseWhiteBg: true
      }
    })

    window.dispatchEvent(event)

    return () => {
      const event = new CustomEvent('background-color', {
        detail: {
          shouldUseWhiteBg: false
        }
      })

      window.dispatchEvent(event)
    }
  }, [])

  return (
    <ErrorViewComponent
      code={errorId ?? 9999}
      buttonMenu={() => history.goBack()}
      onRetry={(code) => {
        gtag('event', 'Click', { event_category: GTM_EVENT_CATEGORY, event_label: 'ERROR - Dudas', value: '10' })

        if (code === 153) return push('/profile')

        push('/help')
      }}
    />
  )
}

export default ErrorView
